module.exports = __webpack_public_path__ + "static/thumbs-up-spaceman-a5faae636fd67b44c0e38403c0de6877.png";